import * as React from 'react'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import '../styles/Modal.scss'
import CameraIcon from '../assets/imgs/profile-screen-images/camera-icon.svg'
import { Button, FormHelperText, Hidden, TextField } from '@mui/material'
import CustomInput from '../components/styled/CustomInput.styled'
import { getDataById, saveOrUpdateDataById } from '../apis/generalApis'
import Swal from 'sweetalert2/dist/sweetalert2'
import GooglePlacesAutocomplete, {
  geocodeByAddress,
  geocodeByLatLng,
  geocodeByPlaceId,
  getLatLng,
} from 'react-google-places-autocomplete'
import { ScaleLoader } from 'react-spinners'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  maxHeight: '90vh',
  overflow: 'auto',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  outline: 'none',
  borderRadius: '16px',
  textAlign: 'center',
}

const EditProfileDetails = ({
  handleEditProfileDetailsModal,
  editProfileDetailsModalOpen = false,
  setUser,
  getStylistProfile,
}) => {
  const user = JSON.parse(localStorage.getItem('user'))
  const [isLoading, setIsLoading] = React.useState(false)
  const [userInfo, setUserInfo] = React.useState({
    image: user?.profile_image ?? '',
    first_name: user?.first_name ?? '',
    last_name: user?.last_name ?? '',
    email: user?.email ?? '',
    phone: user?.phone_number ?? '',
    zipCode: user?.zip_code ?? '',
    country: user?.country ?? '',
    about: user?.about ?? '',
    user_id: user?.id ?? '',
    profile_image: user?.profile_image ?? '',
    title: user?.title ?? '',
    travel_charges: user?.travel_charges ?? '',
    address: user?.address ?? '',
    longitude: user?.longitude ?? '',
    latitude: user?.latitude ?? '',
    primary_image_url: '',
  })
  React.useEffect(() => {}, [])

  const handleChange = (e) => {
    setUserInfo({ ...userInfo, [e.target.name]: e.target.value })
  }

  const [value, setValue] = React.useState(userInfo?.address ?? null)

  const updateUserInfo = async (e) => {
    e.preventDefault()
    if (
      userInfo?.about !== '' &&
      userInfo?.country !== '' &&
      userInfo?.email !== '' &&
      userInfo?.phone !== '' &&
      userInfo?.zipCode !== ''
    ) {
      let formData = new FormData()
      formData.append('first_name', userInfo?.first_name)
      formData.append('last_name', userInfo?.last_name)
      formData.append('user_id', userInfo?.user_id)
      formData.append('about', userInfo?.about)
      formData.append('country', userInfo?.country)
      formData.append('zip_code', userInfo?.zipCode)
      formData.append('phone', userInfo?.phone)
      formData.append('email', userInfo?.email)
      formData.append('title', userInfo?.title)
      formData.append('travel_charges', userInfo?.travel_charges)
      formData.append('location', value?.label)
      formData.append('latitude', userInfo?.latitude)
      formData.append('longitude', userInfo?.longitude)
      if (typeof userInfo?.image !== 'string') {
        formData.append('image', userInfo?.image)
      }
      setIsLoading(true)
      let result = await saveOrUpdateDataById('update-user', formData)
      setIsLoading(false)
      if (result?.data && result?.success === true) {
        handleEditProfileDetailsModal(false)
        localStorage.setItem('user', JSON.stringify(result?.data))
        setUserInfo((prev) => ({ ...prev, ...result?.data }))
        setUser(result?.data)
        getStylistProfile()
        Swal.fire({
          icon: 'success',
          title: 'Profile updated successfully!',
          timer: 3000,
          confirmButtonColor: '#2597F6',
        })
      }
    }
  }

  const handleImageUpload = async (e) => {
    if (!e.target.files[0]) return
    const formData = new FormData()
    formData.append('file', e.target.files[0])
    setIsLoading(true)
    const response = await getDataById('upload-file', formData)
    setIsLoading(false)
    if (response?.success === true) {
      setUserInfo((prev) => ({
        ...prev,
        image: e.target.files[0],
        profile_image: e.target.files[0],
        primary_image_url: response?.data,
      }))
    }
  }

  React.useEffect(() => {
    if (value?.label) {
      setUserInfo((prev) => ({ ...prev, address: value?.label }))
    }
    if (value?.value?.place_id) {
      geocodeByPlaceId(value?.value?.place_id)
        .then((results) => {
          const latLng = getLatLng(results[0])
            .then((coordinates) => {
              setUserInfo((prev) => ({
                ...prev,
                latitude: coordinates?.lat,
                longitude: coordinates?.lng,
              }))
            })
            .catch((err) => console.log(err))
        })
        .catch((error) => console.error(error))
    }
  }, [value])

  return (
    <>
      <ScaleLoader
        color="#36d7b7"
        loading={isLoading}
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          height: '100%',
          top: 0,
          display: 'flex',
          zIndex: 2000,
          justifyContent: 'center',
          alignItems: 'center',
          backdropFilter: 'blur(10px)',
          background: '#ffffff00 0% 0% no-repeat padding-box',
        }}
      />
      <Modal
        open={editProfileDetailsModalOpen}
        onClose={() => handleEditProfileDetailsModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="modal-width">
          <div className="text-center">
            <h3 className="fs-24 mb-4 fw-bold">Edit Profile Details</h3>
            <form onSubmit={updateUserInfo}>
              <div className="m-auto mb-2">
                <label
                  htmlFor="profile-picture"
                  className="edit-profile-modal p-4 pointer position-relative"
                  style={{
                    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${
                      typeof userInfo?.profile_image === 'string'
                        ? userInfo?.profile_image
                        : userInfo?.primary_image_url
                    })`,
                  }}
                >
                  <img src={CameraIcon} alt="" height={25} width="auto" />
                  <TextField
                    type="file"
                    name="profile-image"
                    onChange={handleImageUpload}
                    id="profile-picture"
                    style={{ display: 'none' }}
                  />
                </label>
              </div>
              <div className="row">
                <div className="col-6">
                  <FormHelperText
                    id="input-label"
                    className="mt-2"
                    margin="dense"
                  >
                    First Name
                  </FormHelperText>
                  <CustomInput
                    margin="dense"
                    placeholder="Jane"
                    name="first_name"
                    fullWidth={true}
                    required
                    type="text"
                    value={userInfo?.first_name}
                    onChange={handleChange}
                  />
                  {/* {userInfo?.name === '' && (
                  <FormHelperText style={{ color: 'red' }}>
                    Name should not be empty.
                  </FormHelperText>
                )} */}
                </div>
                <div className="col-6">
                  <FormHelperText
                    id="input-label"
                    className="mt-2"
                    margin="dense"
                  >
                    Last Name
                  </FormHelperText>
                  <CustomInput
                    margin="dense"
                    placeholder="Doe"
                    name="last_name"
                    fullWidth={true}
                    required
                    type="text"
                    value={userInfo?.last_name}
                    onChange={handleChange}
                  />
                  {/* {userInfo?.name === '' && (
                  <FormHelperText style={{ color: 'red' }}>
                    Name should not be empty.
                  </FormHelperText>
                )} */}
                </div>
              </div>
              <div>
                <FormHelperText
                  id="input-label"
                  className="mt-2"
                  margin="dense"
                >
                  Email
                </FormHelperText>
                <CustomInput
                  margin="dense"
                  placeholder="janedoe@gmail.com"
                  name="email"
                  fullWidth={true}
                  type="email"
                  required
                  value={userInfo?.email}
                  onChange={handleChange}
                />
                {/* {userInfo?.email === '' && (
                  <FormHelperText style={{ color: 'red' }}>
                    Email should not be empty.
                  </FormHelperText>
                )} */}
              </div>
              {user?.user_type === 'provider' && (
                <div>
                  <FormHelperText
                    id="input-label"
                    className="mt-2"
                    margin="dense"
                  >
                    Stylist Title
                  </FormHelperText>
                  <CustomInput
                    margin="dense"
                    placeholder="Hair Stylist"
                    name="title"
                    fullWidth={true}
                    required
                    type="text"
                    value={userInfo?.title}
                    onChange={handleChange}
                  />
                </div>
              )}
              <div>
                <FormHelperText
                  id="input-label"
                  className="mt-2"
                  margin="dense"
                >
                  Phone
                </FormHelperText>
                <CustomInput
                  margin="dense"
                  placeholder="+1-234-567-890"
                  name="phone"
                  fullWidth={true}
                  required
                  type="text"
                  value={userInfo?.phone}
                  onChange={handleChange}
                />
                {/* {userInfo?.phone === '' && (
                  <FormHelperText style={{ color: 'red' }}>
                    Phone number should not be empty.
                  </FormHelperText>
                )} */}
              </div>
              <div>
                <FormHelperText
                  id="input-label"
                  className="mt-2"
                  margin="dense"
                >
                  ZIP Code
                </FormHelperText>
                <CustomInput
                  margin="dense"
                  placeholder="90001"
                  name="zipCode"
                  fullWidth={true}
                  required
                  type="number"
                  value={userInfo?.zipCode}
                  onChange={handleChange}
                />
                {/* {userInfo?.zipCode === '' && (
                  <FormHelperText style={{ color: 'red' }}>
                    Zip code should not be empty.
                  </FormHelperText>
                )} */}
              </div>
              <div>
                <FormHelperText
                  id="input-label"
                  className="mt-2"
                  margin="dense"
                >
                  Country
                </FormHelperText>
                <CustomInput
                  margin="dense"
                  placeholder="USA"
                  name="country"
                  required
                  fullWidth={true}
                  type="text"
                  value={userInfo.country}
                  onChange={handleChange}
                />
              </div>
              {user?.user_type === 'provider' && (
                <>
                  <div>
                    <FormHelperText
                      id="input-label"
                      className="mt-2"
                      margin="dense"
                    >
                      Address
                    </FormHelperText>
                    <div className="autoplaces-container mb-2">
                      <GooglePlacesAutocomplete
                        selectProps={{
                          value,
                          onChange: setValue,
                          onSelect: (e) => {},
                          styles: {
                            control: (base, state) => ({
                              ...base,
                              border: '1px solid #08c4bb',
                              // This line disable the blue border
                              boxShadow: state.isFocused ? 0 : 0,
                              '&:hover': {
                                border: '1px solid #08c4bb',
                              },
                            }),
                            input: (provided) => ({
                              ...provided,
                            }),
                            container: (provided) => ({
                              ...provided,
                              // border: '1px solid #08c4bb',
                              borderRadius: '8px',
                            }),
                          },
                          isClearable: true,
                          defaultInputValue: userInfo?.address,
                        }}
                      ></GooglePlacesAutocomplete>
                    </div>
                  </div>
                  <div>
                    <FormHelperText
                      id="input-label"
                      className="mt-2"
                      margin="dense"
                    >
                      Travel Charges
                    </FormHelperText>
                    <CustomInput
                      margin="dense"
                      placeholder="Travel charges per hour"
                      name="travel_charges"
                      required
                      fullWidth={true}
                      type="text"
                      value={userInfo.travel_charges}
                      onChange={handleChange}
                    />
                  </div>
                </>
              )}
              {user?.user_type != 'client' && (
                <div>
                  <FormHelperText
                    id="input-label"
                    className="mt-2"
                    margin="dense"
                  >
                    About You
                  </FormHelperText>
                  <div className="bordered-text px-2 pt-2 text-left">
                    <textarea
                      className="customer-support-message"
                      name="about"
                      cols="30"
                      rows="5"
                      required
                      value={userInfo?.about}
                      onChange={handleChange}
                    ></textarea>
                  </div>
                  {/* {userInfo?.about === '' && (
                    <FormHelperText style={{ color: 'red' }}>
                      About you should not be empty.
                    </FormHelperText>
                  )} */}
                </div>
              )}
              <Button
                fullWidth={true}
                disableElevation
                className="mt-5"
                type="submit"
                id="btn-primary-no-shadow"
                // onClick={updateUserInfo}
              >
                Save Changes
              </Button>
            </form>
          </div>
        </Box>
      </Modal>
    </>
  )
}

export default EditProfileDetails
